/**
 * Обрабатываем поля custom_select для одного элемента
 * @param object
 * @returns {boolean}
 */
window.handlingSelect = object => {

    // object = label
    // select = div
    const select = object.closest('.custom_select');
    // list = ul
    const list = object.closest('.select__list');
    // input = hidden input
    let input = select.find('.custom_select_input');
    // button = dropdown button
    let button = select.find('.custom_select_btn');
    // span = dropdown span with text
    let span = object.find('span');

    let textFull = span.text();

    button.text(trimString(textFull)).removeClass('active');

    const value = $.hasData(object) ? object.data('id') : object.text();
    input.val($.trim(value));

    select.find('.active').each(function () {
        $(this).removeAttr('class');
    });

    object.parent().addClass('active');
}

/**
 * Подготавливаем строку с названиями и сохраняем в текст кнопки формы
 * @param object Получаем label названия
 * @param array Получаем массив, в котором будем сохранять значения
 * @param key Получаем ключ массива для сохранения
 */
window.prepareSelectHandle = (object, array, key = null) => {
    const select = object.closest('.custom_select');
    let button = select.find('.custom_select_btn');

    // Получаем либо полное название, либо false
    let element = handlingSelectSeveralItems(object);

    let filterValues = select.find('.filter__values');
    let filterString = '';
    let buttonText = '';

    if (element) {
        let elementPosition = $.inArray(element, array[key]);
        elementPosition < 0 ? array[key].push(element) : array[key].splice(elementPosition, 1);

        // Если массив пустой, то используем текст по-умолчанию
        if (array[key].length !== 0) {
            filterString = array[key].join(', ');
            buttonText = trimString(filterString, 20);
        } else {
            buttonText = button.data('default');
        }
        button.text(buttonText);
    } else {
        button.text(object.attr('data-text'));
        filterString = '';
        array[key].length = 0;
    }

    filterValues.val(filterString).change();
}

/**
 * Обрабатываем поля custom_select для нескольких элементов
 * @param object
 * @returns string|false
 */
window.handlingSelectSeveralItems = object => {
    // object = label
    // select = div
    const select = object.closest('.custom_select');
    // list = ul
    const list = object.closest('.select__list');
    // button = dropdown button
    let button = select.find('.custom_select_btn');
    // span = dropdown span with text
    let span = object.find('span');

    let textFull = span.text();

    let defaultItem = object.attr('data-type') === 'default';

    if (defaultItem) {
        textFull = object.attr('data-text');
        list.addClass('active');
        list.find('li').removeClass('active');
        button.removeAttr('data-value').removeClass('active');
    } else {
        list.removeClass('active');
        list.find('label[data-type=default]').parent().removeClass('active');
        object.parent().toggleClass('active');
    }

    return defaultItem ? false : textFull;
};

/**
 * Обрезаем строку по количеству символов
 * @param text
 * @param chars Количество символов
 */
window.trimString = (text, chars = 30) => (text.length > chars) ? text.slice(0, chars) + '...' : text;

/**
 * Очищаем поля формы
 * @param form
 */
window.resetForm = form => {
    let priceRange = $(".js-range-slider").data("ionRangeSlider");

    if (typeof (priceRange) != "undefined") {
        priceRange.reset();
    }

    let prices = $('#top-filter__prices .rangeValues');
    prices.find('.rangeFrom').text("1");
    prices.find('.rangeTo').text("30000");

    if (typeof (form[0]) != "undefined" && form[0] !== null) {
        form[0].reset();
    }

    // Поля модальных окон
    form.find('.button__time-from').text('С');
    form.find('.button__time-to').text('До');
    form.find('.button__numbers').text('Выберите номер');
    form.find('.button__promos').text('Используйте скидку');
    form.find('.input--date').attr({type: 'text'});
    form.find('.button__owner-type').text('В лице ген. директора/ИП');
    form.find('.button__company-type').text('Выберите тип предприятия');

    // Поля фильтра делаем с текстом по-умолчанию
    form.find('button').each(function () {
        $(this).text($(this).data('default'));
    });

    form.find('li').removeClass('active');
    form.find('label[data-type=default]').parent().addClass('active');
};


/**
 * Получение саун через ajax-запрос
 * @param {{persons: number, types: [], priceFrom: number, sorting: string, districts: [], stations: [], page: number, priceTo: number}} filters
 * @param {any} cityUrl Url города
 * @param {boolean} append Использовать автоподгрузку заведений?
 * @param {*} button - кнопка show-more
 * @param wrapperClass
 * @param parentClass
 * @param messages
 */
window.getSaunas = (filters = {}, cityUrl = null, append = false, button = '', wrapperClass = '', messages = {'shownAll': 'Показаны все заведения', 'notFound': 'Заведения не найдены'}, parentClass = '.city__saunas') => {

    let wrapperClassName = wrapperClass.substr(1);
    let parentClassName = parentClass.substr(1);

    // Инициируем настройки ajax
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $.ajax({
        cache: false,
        type: 'get',
        url: cityUrl,
        data: filters,
        beforeSend: function () {
            if (button !== '') {
                button.find('.button-spinner').show();
            }
            $('.preloader').css('display', 'flex');
        },
        complete: function () {
            $('.preloader').hide();
            if (button !== '') {
                button.find('.button-spinner').hide();
            }

            $(".img_slide").owlCarousel({
                items: 1,
                loop: !0,
                autoplay: !0,
                dots: !0,
                autoplayTimeout: 5e3,
                autoplayHoverPause: !1,
                lazyLoad: true
            });
        },
        success: function (data) {
            let totalCount = data.saunasTotalCount;
            let placeShowMore = $('.places__button--more');
            let showMoreButton = placeShowMore.find('.show-more');
            let noMoreElement = placeShowMore.find('.no-more');

            if (data.view !== '') {
                noMoreElement.hide();

                if (button !== '') {
                    button.css('display', 'flex');
                }

                if (append) {
                    if (wrapperClass !== '') {
                        $(`<div class='${wrapperClassName} mt-2'>${data.view}</div>`).appendTo(`${parentClass}`);
                    } else {
                        $(`${parentClass}`).append(data.view);
                    }
                } else {

                    if (wrapperClass !== '') {
                        $(`${parentClass}`).html(`<div class='${wrapperClassName}'>${data.view}</div>`);
                    } else {
                        $(`${parentClass}`).html(data.view);
                    }
                }

                if(filters.page === totalCount) {
                    showMoreButton.hide();
                    noMoreElement.html(messages.shownAll).show();
                } else {
                    showMoreButton.css('display', 'flex');
                }

                if($(data.view).hasClass('saunas-empty')) {
                    showMoreButton.hide();
                    noMoreElement.html(messages.shownAll).show();
                }
            } else {
                showMoreButton.hide();
                noMoreElement.html(messages.shownAll).show();
            }
        },
        error: function (xhr, status, error) {
            let errorMessage = xhr.status + ': ' + xhr.statusText;
            console.log('Error getSaunas - ' + errorMessage);
        }
    });
}

/**
 * Формируем строку с ценами
 * @param sauna
 * @returns {string}
 */
window.getPriceString = (sauna) => {
    let costs = '';

    if (+sauna.min_price === +sauna.max_price) {
        costs = sauna.min_price + ' р/час';
    } else {
        costs = 'от ' + sauna.min_price + ' до ' + sauna.max_price + ' р/час';
    }

    return costs;
}

/**
 * Меняем местами долготу и широту у сауны
 * @param data
 * @returns {[*, *]|boolean}
 */
window.swapCoords = (data) => {
    if (data === '') {
        return false;
    }

    let coords = data.split(',');

    return [coords[0], coords[1]] = [coords[1], coords[0]];
}

/**
 * Формирование Яндекс.Карты по координатам
 * @param domId Идентификатор контейнера в DOM-дереве
 * @param data
 * @param city
 * @param zoom
 */
window.getYandexMap = (domId = 'map', data = {}, city = {}, zoom = 14) => {

    let coords = swapCoords(city.smapc) || [55.73, 37.75];

    if (swapCoords(data.smapc)) {
        coords = swapCoords(data.smapc);
    }

    const myMapSingle = new ymaps.Map(domId, {
        center: coords,
        zoom: zoom
    }, {
        suppressMapOpenBlock: true
    });

    let contentString = '';

    if (Object.keys(data).length > 0) {
        contentString = '<strong>' + data.title + '</strong><br>' + data.address + '<br>' + getPriceString(data);
    }

    myMapSingle.geoObjects
        .add(new ymaps.Placemark(coords, {
            balloonContent: contentString
        }, {
            preset: 'islands#icon',
            iconColor: '#0095b6'
        }));
}

/**
 * Формирование Яндекс.Карты по координатам (все сауны города на карте)
 * @param domId
 * @param data
 * @param city
 * @param zoom
 */
window.getYandexMapSeveralObjects = (domId = 'map', data = {}, city = {}, zoom = 14) => {

    let centerCoords = swapCoords(city) || [55.73, 37.75];

    // let firstSaunaCoords = swapCoords(data[0].smapc);
    //
    // if (firstSaunaCoords) {
    //     centerCoords = firstSaunaCoords;
    // }

    const myMap = new ymaps.Map(domId, {
        center: centerCoords,
        zoom: zoom
    });

    let saunasCollection = new ymaps.GeoObjectCollection(null, {
        preset: 'islands#icon'
    });

    for (let i = 0, l = data.length; i < l; i++) {

        let sauna = data[i];

        let contentString = '';

        if (Object.keys(sauna).length > 0) {
            contentString = '<strong>' + sauna.bigtitle + '</strong><br>' + sauna.address + '<br>' + getPriceString(sauna);
        }

        let coords = swapCoords(sauna.smapc) || centerCoords;

        saunasCollection.add(new ymaps.Placemark(coords, {
            balloonContent: contentString
        }, {
            preset: 'islands#icon',
            iconColor: '#0095b6'
        }));
    }

    myMap.geoObjects.add(saunasCollection);
}

/**
 * Обработчик кнопки Поделиться в мобильной версии (шапка)
 * @type {Element}
 */
const btn = document.querySelector('.share__button');

btn.addEventListener('click', async () => {

    const shareData = {
        title: document.title,
        text: document.querySelector("meta[name='description']").getAttribute('content'),
        url: window.location.href,
    }

    try {
        await navigator.share(shareData);
    } catch (err) {
        console.log('Error: ' + err);
    }
});

/**
 * Установка курсора в требуемую позицию при нажатии на input.
 * Для плагина jQuery.Maskedinput
 * @param pos
 */
// window.setCursorPosition = (pos) => {
//     if ($(this).get(0).setSelectionRange) {
//         $(this).get(0).setSelectionRange(pos, pos);
//     } else if ($(this).get(0).createTextRange) {
//         var range = $(this).get(0).createTextRange();
//         range.collapse(true);
//         range.moveEnd('character', pos);
//         range.moveStart('character', pos);
//         range.select();
//     }
// };


window.removeAllChildNodes = (parent) => {
    while (parent.firstChild) {
        parent.removeChild(parent.firstChild);
    }
}
